import CurriculumInfo from "./Curriculum/CurriculumInfo";
import GradeManagementInfo from "./GradeMgmt/GradeManagementInfo";

const CurriculumMgmtInfo = () => {
  // const {
  //   currentTab,
  //   action,
  //   onTabChange
  // } = useCurriculumMgmtInfo();

  return (
    <div className="bg-white p-5">
      <CurriculumInfo />
      <GradeManagementInfo />
      {/* <h2 className="text-[18px] text-primary mb-5">Grade Management</h2> */}
    </div>
  );
};

export default CurriculumMgmtInfo;
